import React from 'react'

import { Tag } from 'antd'

import { emptyCharacter } from '../../../components/EmptyChar'
import { renderEmailLinkColumn } from '../../../components/tables'
import { renderDateTimeColumn } from '../../../components/tables/columns/render-date-column'
import { toFixed } from '../../../formatters'
import { QuoteStatus } from '../models'

const quoteStatusColors = {
  confirmed: 'green',
  accepted: 'blue',
  pending: 'warning',
  rejected: 'default',
}

const renderCoupon = (coupon: number) => (coupon ? toFixed({ value: coupon }) : emptyCharacter)

export const renderQuoteStatus = (status: string) =>
  status ? (
    <Tag color={quoteStatusColors[status]} className="capitalize">
      {status}
    </Tag>
  ) : (
    emptyCharacter
  )

const renderWinnerStatus = (status: QuoteStatus) => {
  const getIsWinningQuote = (status: QuoteStatus) => ['accepted', 'confirmed'].includes(status)
  const isWinningQuote = getIsWinningQuote(status)

  return <Tag color={isWinningQuote ? 'green' : 'default'}>{isWinningQuote ? 'Yes' : 'No'}</Tag>
}

export const quotesColumns = [
  { title: 'Tenor', dataIndex: 'tenor' },
  { title: 'ADI', dataIndex: 'issuerCode' },
  { title: 'Cust. Rate', dataIndex: 'coupon', render: renderCoupon },
  { title: 'Quoted Rate', dataIndex: 'bankCoupon', render: renderCoupon },
  { title: 'Quoted By', dataIndex: 'respondedBy', render: renderEmailLinkColumn },
  { title: 'Quoted At', dataIndex: 'receivedAt', render: renderDateTimeColumn },
  { title: 'Status', dataIndex: 'status', render: renderQuoteStatus },
  { title: 'Winner', dataIndex: 'status', render: renderWinnerStatus },
]
